import React from 'react';
import Content from '../components/content';
import Image from '../components/image';
import Footer from '../components/footer';
import Layout from '../components/layout';
import CaseHeader from '../components/case-header';

const Typeform = () => (
    <Layout>
        <CaseHeader
            title="GitHub"
            role="Systems Design"
            time="2022&ndash;2023"
            imgSrc={require('../assets/images/github/header-1.gif')}
            alt="GitHub's Primer design system"
            description="GitHub is a software development platform that allows developers to build, ship, and scale their software."
            quote="GitHub’s mission is to make software development faster and easier for everyone."
            quoteAuthor="Chris Wanstrath"
            quoteAuthorRole="Co-founder of GitHub"
        />
        <section>
            <Content kind="p" tag="h2">
                Intro
            </Content>
            <Content>
                I joined GitHub in 2022 as a Systems Designer to work on the{' '}
                <a href="https://primer.style/">Primer</a> design system. Primer is an open-source
                design system that provides a set of components and tools for building web
                applications. My main goal was to improve, optimize, and standardize the design
                system to help the team build better products faster.
            </Content>
        </section>
        <section>
            <Content kind="p" tag="h2">
                Figma automation
            </Content>
            <Content>
                As part of my onboarding project, I was in charge of building a small prototype
                using Primer to understand the automation possibilities inside and outside of Figma
                and how that could fit into the larger Primer ecosystem. Along with{' '}
                <a href="https://github.com/danielguillan/">Daniel Guillan</a> and{' '}
                <a href="https://github.com/lukasoppermann/">Lukas Oppermann</a>, we worked on a
                little experiment to explore the Figma REST API to built a basic service that
                automatically extracts component data from our Figma library and generate a basic{' '}
                <a href="https://figma-docgen.vercel.app/">documentation site</a>.
            </Content>
            <Content>
                After the initial prototype, we built a more robust service that automatically
                extracts all the component data from our Figma library that later we embedded in our
                documentation site. This way we can keep the documentation site up to date with the
                latest changes in our Figma library and show some useful information about the
                components, such as the props, the component variants, states, and even present them
                in a live preview.
            </Content>
        </section>
        <section>
            <Content kind="p" tag="h2">
                Primer
            </Content>
            <Content></Content>
            <Image
                alt="JSON file sample (left) with dynamically generated content. The prototype (right) filled with the new content ready to be used in user test sessions."
                src={require('../assets/images/typeform/fake-data-json.jpg')}
            />
        </section>
        <section>
            <Content kind="p" tag="h2">
                Primer Brand
            </Content>
            <Content></Content>
        </section>
        <Footer>
            <a href="./new-relic">
                <img
                    loading="lazy"
                    src={require('../assets/images/new-relic/header-3.gif')}
                    alt={'New Relic use case'}
                />
            </a>
            <a href="./typeform">
                <img
                    loading="lazy"
                    src={require('../assets/images/typeform/header-3.gif')}
                    alt={'Typeform use case'}
                />
            </a>
        </Footer>
    </Layout>
);

export default Typeform;
